<template>
  <transition name="fade">
    <el-dialog class="want-call" v-if="dialogFormVisible" width="40%" title="Хотите мы вам перезвоним?"
      :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="Ваше имя">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="Номер телефона">
          <el-input v-mask="mask" :placeholder="placeholder" v-model="form.phone" autocomplete="off">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button :loading="loading" type="primary" @click="sendForm()">
          Отправить
        </el-button>
      </span>
    </el-dialog>
  </transition>
</template>
  
<script>
import { mapActions } from "vuex"

export default {
  data() {
    return {
      dialogFormVisible: false,
      loading: false,
      form: {
        name: '',
        phone: ''
      },
      mask: "+### ## ### ## ##",
      placeholder: "+998 ()",
    }
  },

  mounted() {
    setTimeout(() => {
      this.dialogFormVisible = true
    }, 6000)
  },

  computed: {

  },

  methods: {
    ...mapActions({
      sendClientInfo: "flats/sendClientInfo"
    }),

    sendForm() {
      this.loading = true
      this.sendClientInfo(this.form)
        .then((res) => {
          this.dialogFormVisible = false
          this.loading = false
          this.form = {
            name: '',
            phone: ''
          }
          this.$message({
            message: 'Успешно отправлено!',
            type: 'success'
          })
        })
        .catch((err) => {
          this.loading = false
        })
    }
  }
}
</script>
  
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.el-dialog {
  background: #2a2e36;
  border-radius: 0;
  border: 1px solid #ca9760;

  .el-dialog__title,
  .el-form-item__label {
    color: white;
  }

  input {
    border: 1px solid #ca9760;
    background: transparent;
    border-radius: 0;

    &:focus {
      border: 1px solid #ca9760;
    }
  }

  .el-icon-close {
    transition: 0.4s;

    &:before {
      font-size: 26px;
    }

    &:hover {
      color: #ca9760;
    }
  }

  .el-button {
    background: none;
    border: #ca9760 1px solid;
    border-radius: 0;
  }
}
</style>
  